import { queryClient, usePersistQueryClient } from '@/config/queryClient'
export { queryClient, usePersistQueryClient }
